import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { SignupComponent } from './components/signup/signup.component';
import { SelectMallComponent } from './components/select-mall/select-mall.component';
import { VerifyOtpComponent } from './components/verify-otp/verify-otp.component';
import { SetPasswordComponent } from './components/set-password/set-password.component';
import { LoginWithOtpComponent } from './components/login-with-otp/login-with-otp.component';
import { LoginWithPasswordComponent } from './components/login-with-password/login-with-password.component';
import { SocialSigninRegisterNumberComponent } from './components/social-signin-register-number/social-signin-register-number.component';
import { SocialSigninVerifyOtpComponent } from './components/social-signin-verify-otp/social-signin-verify-otp.component';
import { LoginOldComponent } from './components/login-old/login-old.component';
import { SignupOldComponent } from './components/signup-old/signup-old.component';
import { SocialSigninRegisterNumberOldComponent } from './components/social-signin-register-number-old/social-signin-register-number-old.component';
import { SocialSigninSelectMallComponent } from './components/social-signin-select-mall/social-signin-select-mall.component';

const routes: Routes = [
 
  {
    path: '',
    redirectTo: 'fynd-login',
    pathMatch: 'full',
  },
  { 
    path: 'select-mall', 
    component: SelectMallComponent, 
  },
  { 
    path: 'fynd-verify-otp', 
    component: VerifyOtpComponent,
  },
  { 
    path: 'set-password', 
    component: SetPasswordComponent,
  },

  { 
    path: 'login-with-otp', 
    component: LoginWithOtpComponent, 
  },
  { 
    path: 'login-with-password', 
    component: LoginWithPasswordComponent,
  },
  { 
    path: 'social-signin-verify-otp', 
    component: SocialSigninVerifyOtpComponent,
  },
  { 
    path: 'social-signin-select-mall', 
    component: SocialSigninSelectMallComponent,
  },
   /*****WIth CDN */
  {
    path:'fynd-login', 
    component:LoginComponent
  },
   { 
    path: 'fynd-signup', 
    component: SignupComponent,
  },
  { 
    path: 'social-signin-register-number', 
    component: SocialSigninRegisterNumberComponent,
  },
  /*****WIth OKENapi */
  {
    path:'fynd-login-old', 
    component:LoginOldComponent
  },
  { 
    path: 'fynd-signup-old', 
    component: SignupOldComponent,
  },
  { 
    path: 'social-signin-register-number-old', 
    component: SocialSigninRegisterNumberOldComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
